var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionmarkIconImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "questionmark-icon-img",
    transform: "translate(4875 5301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "questionmark-icon-img-2",
    "data-name": "questionmark-icon-img",
    d: "M8.624-12.27A4.006,4.006,0,0,1,7.71-9.452a5.5,5.5,0,0,1-.958.836q-.49.33-1.27.748v1.5H1.76V-8.814a1.99,1.99,0,0,1,.3-1.145,2.223,2.223,0,0,1,.992-.737A4,4,0,0,0,4-11.213a.743.743,0,0,0,.256-.594q0-.638-.758-.638a26.328,26.328,0,0,0-2.875.462v-3.83a17.8,17.8,0,0,1,3.744-.462Q8.624-16.276,8.624-12.27ZM3.632-2.276a2.587,2.587,0,0,1-1.694-.429,1.679,1.679,0,0,1-.49-1.332,1.7,1.7,0,0,1,.479-1.332,2.581,2.581,0,0,1,1.7-.429,2.532,2.532,0,0,1,1.694.429,1.724,1.724,0,0,1,.468,1.332,1.7,1.7,0,0,1-.479,1.332A2.538,2.538,0,0,1,3.632-2.276Z",
    transform: "translate(-4870.624 -5282.724)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_620",
    "data-name": "Rectangle 620",
    width: 18,
    height: 18,
    transform: "translate(-4875 -5301)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionmarkIconImg);
export default __webpack_public_path__ + "static/media/questionmark-icon-img.e170ce6add16473c0c07008aac21991b.svg";
export { ForwardRef as ReactComponent };